import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Button from '../shared/Button.svelte';
import Card from '../shared/Card.svelte';
import { createSyncGroup } from '../../lib/services/sync';
import { showToast } from '../shared/Toast.svelte';

var root_1 = $.from_html(`<div class="invite svelte-33t0nij9w9n1b"><h3 class="svelte-33t0nij9w9n1b">Invite Partner <span class="coming-soon-badge svelte-33t0nij9w9n1b">Coming Soon</span></h3> <p class="hint svelte-33t0nij9w9n1b">Partner invite codes require cloud sync, which is not yet available. This feature is coming in a future update.</p> <!></div>`);

function InvitePartner($$anchor, $$props) {
	$.push($$props, true);

	let inviteCode = $.state(null);

	async function handleGenerate() {
		$.set(inviteCode, await createSyncGroup(), true);
	}

	async function handleCopy() {
		if ($.get(inviteCode)) {
			await navigator.clipboard.writeText($.get(inviteCode));
			showToast('Code copied!', 'success');
		}
	}

	var fragment = $.comment();
	var node = $.first_child(fragment);

	Card(node, {
		padding: 'md',
		children: ($$anchor, $$slotProps) => {
			var div = root_1();
			var node_1 = $.sibling($.child(div), 4);

			Button(node_1, {
				variant: 'secondary',
				fullWidth: true,
				disabled: true,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text = $.text('Generate Invite Code');

					$.append($$anchor, text);
				},
				$$slots: { default: true }
			});

			$.reset(div);
			$.append($$anchor, div);
		},
		$$slots: { default: true }
	});

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	InvitePartner = $.hmr(InvitePartner);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-33t0nij9w9n1b');
		InvitePartner[$.HMR].update(module.default);
	});
}

export default InvitePartner;
import "bun-svelte:InvitePartner.svelte-27gciih40v93r-style.css";